import Glyph from '../base/Glyph/Glyph';

export function PencilGlyph({className, children}) {
    return Glyph({additionalClass:className, glyph:"glyphicon-pencil", children:children});
}

export function SearchGlyph({className, children}) {
    return Glyph({additionalClass:className, glyph:"glyphicon-search", children:children});
}

export function UserGlyph({className, children}) {
    return Glyph({additionalClass:className, glyph:"glyphicon-user", children:children});
}

export function OkGlyph({className, children}) {
    return Glyph({additionalClass:className, glyph:"glyphicon-ok", children:children});
}

export function ListGlyph({className, children}) {
    return Glyph({additionalClass:className, glyph:"glyphicon-list-alt", children:children});
}

export function PlusGlyph({className, children}) {
    return Glyph({additionalClass:className, glyph:"glyphicon-plus", children:children});
}

export function TrashGlyph({className, children}) {
    return Glyph({additionalClass:className, glyph:"glyphicon-trash", children:children});
}

export function RemoveGlyph({className, children}) {
    return Glyph({additionalClass:className, glyph:"glyphicon-remove", children:children});
}

export function FloppyDiskGlyph({className, children}) {
    return Glyph({additionalClass:className, glyph:"glyphicon-floppy-disk", children:children});
}

export function LeftGlyph({className, children}) {
    return Glyph({additionalClass:className, glyph:"glyphicon-chevron-left", children:children});
}

export function RightGlyph({className, children}) {
    return Glyph({additionalClass:className, glyph:"glyphicon-chevron-right", children:children});
}

export function QuestionGlyph({className, children}) {
    return Glyph({additionalClass:className, glyph:"glyphicon glyphicon-question-sign", children:children});
}


// WEBPACK FOOTER //
// ./src/components/glyphicons/Glyphicons.js